export default __webpack_public_path__ + "ce77ad34bebad653787ac9071b84dbfd.png";